<template>
  <div class="availables__deptos-box">
    <div class="availables__deptos-title filters__web">
      <div :class="changeColorCount" class="count">{{ availables }}</div>
      <div class="text">
        <h2>DEPARTAMENTO(S) DISPONIBLE(S)</h2>
      </div>
    </div>
 
    <div class="box__rangers-filters filters__web">
      <div class="box__availables__deptos-buttons custom__apartments-filter-default">
        <div class="availables__deptos-buttons">
          <!-- <div @click="showAllModels()" :class="fillAll" class="availables__casas-buttons-btn"></div> -->
          <div class="availables__casas-buttons-text">
            <font-awesome-icon :class="fillAll" @click="showAllModels()" :icon="iconCircle"
              class="availables__deptos-buttons-btn" />TODOS
          </div>
        </div>
      </div>
      <div class="box__filters">
        <div class="contents-rangers prices-depas">
          <h2 class="center-text range__container-title">
            Filtrar Niveles de Departamentos
          </h2>
          <div class="range__container-item range-price-container" :class="desarrollo === 'torrevistahermosa' ? 'torre-slider-wrapper' : ''">
            <div class="range-numbers range-numbers-left">Número de nivel</div>
            <div class="range-buttons range-buttons-price" :class="desarrollo === 'torrevistahermosa' ? 'torre-large-buttons' : ''">
              <vue-slider v-if="value_2 !== null && minVal !== null && value_2 >= minVal && returnLvls !== null"  class="rangeprice-custom range-price-custom range-depas-levels" v-model="value_2" :min="minVal"
                :max="returnLvls" :adsorb="true" :interval="1" :marks="true" @change="updateActiveModel(returnNames)">
              </vue-slider>
            </div>
          </div>
        </div>
        <div class="box__availables__deptos-buttons custom__apartments-filter-custom">
          <div class="availables__deptos-buttons">
            <!-- <div @click="showAllModels()" :class="fillAll" class="availables__casas-buttons-btn"></div> -->
            <div class="availables__casas-buttons-text">
              <font-awesome-icon :class="fillAll" @click="showAllModels()" :icon="iconCircle"
                class="availables__deptos-buttons-btn" />TODOS
            </div>
          </div>
        </div>
        <div class="contents-rangers" v-if="priceFilterRange">
          <h2 class="center-text range__container-title">
            Filtrar Precios de Departamentos
          </h2>
          <div class="range__container-item range-price-container">
            <div class="range-numbers range-numbers-left">
              {{ formatValue(returnMinPrice) }}
            </div>
            <div class="range-buttons range-buttons-price">
              <vue-slider v-if="rangePrice" class="rangeprice-custom range-price-custom" :tooltip-formatter="(val) => formatValue(val)"
                v-model="rangePrice" :min="returnMinPrice" :max="returnMaxPrice" :enable-cross="false"
                @change="updateActiveModelPrices()">
              </vue-slider>
            </div>
            <div class="range-numbers range-numbers-right">
              {{ formatValue(returnMaxPrice) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <FilterMobile class="filters__mobile">
      <div class="box__rangers-filters">
          <div class="box__availables__deptos-buttons">
            <div class="availables__deptos-buttons">
              <!-- <div @click="showAllModels()" :class="fillAll" class="availables__casas-buttons-btn"></div> -->
              <div class="availables__casas-buttons-text">
                <font-awesome-icon :class="fillAll" @click="showAllModels()" :icon="iconCircle"
                  class="availables__deptos-buttons-btn" />TODOS
              </div>
            </div>
          </div>
          <div class="box__filters">
            <div class="contents-rangers prices-depas">
              <h2 class="center-text range__container-title">
                Filtrar Niveles de Departamentos
              </h2>
              <div class="range__container-item range-price-container" :class="desarrollo === 'torrevistahermosa' ? 'torre-slider-wrapper' : ''">
                <div class="range-numbers range-numbers-left">Número de nivel</div>
                <div class="range-buttons range-buttons-price" :class="desarrollo === 'torrevistahermosa' ? 'torre-large-buttons' : ''">
                  <vue-slider v-if="value_2 !== null && minVal !== null && value_2 >= minVal && returnLvls !== null" class="rangeprice-custom range-price-custom range-depas-levels" v-model="value_2"
                    :min="minVal" :max="returnLvls" :adsorb="true" :interval="1" :marks="true"
                    @change="updateActiveModel(returnNames)" style="width: 100%; max-width: 600px;">
                  </vue-slider>
                </div>
              </div>
            </div>
            <div class="contents-rangers" v-if="priceFilterRange">
              <h2 class="center-text range__container-title">
                Filtrar Precios de Departamentos
              </h2>
              <div class="range__container-item range-price-container">
                <div class="range-numbers range-numbers-left">
                  {{ formatValue(returnMinPrice) }}
                </div>
                <div class="range-buttons range-buttons-price">
                  <vue-slider v-if="rangePrice" class="rangeprice-custom range-price-custom" :tooltip-formatter="(val) => formatValue(val)"
                    v-model="rangePrice" :min="returnMinPrice" :max="returnMaxPrice" :enable-cross="false"
                    @change="updateActiveModelPrices()">
                  </vue-slider>
                </div>
                <div class="range-numbers range-numbers-right">
                  {{ formatValue(returnMaxPrice) }}
                </div>
              </div>
            </div>
          </div>
        </div>
    </FilterMobile>
    <div class="availables__deptos-title filters__mobile">
      <div :class="changeColorCount" class="count">{{ availables }}</div>
      <div class="text">
        <h2>DEPARTAMENTO(S) DISPONIBLE(S)</h2>
      </div>
    </div>
    <!-- <div class="box__availables__deptos-buttons">
        <div
          class="availables__deptos-buttons"
          v-for="(model, index) in setModels"
          :key="index"
        >
          
          <div class="availables__deptos-buttons-text">
            <font-awesome-icon
              :class="fillActive(model)"
              @click="updateActiveModel(model)"
              :icon="iconCircle"
              class="availables__deptos-buttons-btn"
            />{{ model.name }}
          </div>
        </div>
      </div> -->
  </div>
</template>
  
<script>
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { mapGetters, mapActions } from "vuex";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import FilterMobile from "./filter/FilterMobile.vue"
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  components: {
    VueSlider,
    FilterMobile
  },
  props: [
    "existFilter",
    "activeModel",
    "priceFilterRange",
    "priceFilterRangeDtos",
    "desarrollo",
  ],
  data() {
    return {
      closeIcon: faFilter,
      fillAll: "active__btn-deptos",
      mutateModel: "",
      iconCircle: faCircle,
      value_2: null,
      rangePrice: "",
      name: "",
      arrPrices: "",
      minVal: 0,
      openFilter: false,
    };
  },
  computed: {
    ...mapGetters({
      filterModelos: "getStatusFilterModelos",
    }),
    setModels() {
      let personasMap = this.existFilter.map((item) => {
        return [item.name, item];
      });
      var personasMapArr = new Map(personasMap);
      return [...personasMapArr.values()];
    },
    availables() {
      if (this.desarrollo == "torrespaseodelparque" || this.desarrollo =="canadas_deptos") {
        let arr = this.filterModelos.filter((i) => i.available > 0);
        let arrF = []
        for (let index = 0; index < arr.length; index++) {
          arrF[index] = arr[index].available
        }
        const reducer = (accumulator, curr) => accumulator + curr;
        let sum = arrF.reduce(reducer)
        return sum
      } else {
        let arr = this.filterModelos.reduce((sum, i) => {
          return sum + Number(i.available || 0);
        }, 0);
        return arr
      }
    },
    changeColorCount() {
      if (this.available >= 0) {
        return "count__unavailable";
      } else {
        return "count__available";
      }
    },
    returnLvls() {
      let personasMap = this.existFilter.map((item) => {
        return [item.name, item];
      });
      var personasMapArr = new Map(personasMap);

      if (this.desarrollo == 'torreaireaplus' || this.desarrollo == 'torrespanorama' ) {
        return [...personasMapArr.values()].length;
      }else if(this.desarrollo == 'torrespaseodelparque'){
        return personasMap.length-1
      }else if(this.desarrollo =="torrevistahermosa"){
        return personasMap.length-2
      } else {
        return [...personasMapArr.values()].length - 1;
      }
      
    },
    returnNames() {
      if (this.value_2 == 0) {
        if(this.desarrollo==='canadas_deptos'){
          return `${this.name} ${this.value_2}`;
        }else if(this.desarrollo==='torrevistahermosa'){
          return `PB`;
        }else{
          return "PLANTA BAJA";
        }
      } else {
        if (this.desarrollo == 'torrevistahermosa' && this.$route.params.id == 92) {
          if (this.value_2 == -1) {
            return `N-01`
          } else {
            return `${this.name} ${this.value_2}`;
          }
        }
        if (this.desarrollo == 'torrespanorama' && this.$route.params.id == 62) {
          if (this.value_2 == 6) {
            return `PENTHOUSE PLANTA BAJA`
          } else if (this.value_2 == 7) {
            return `PENTHOUSE PLANTA ALTA`
          } else {
            return `${this.name} ${this.value_2}`;
          }
        } else {
          if (this.desarrollo == 'torrespanorama' && this.$route.params.id == 61) {
            if (this.value_2 == 6) {
              return `${this.name} ${this.value_2} `
            } else {
              return `${this.name} ${this.value_2}`
            }
          }
          return `${this.name} ${this.value_2}`;
        }
      }
    },
    returnMinPrice() {
      if (this.priceFilterRange) {
        return Number(this.priceFilterRange[0]);
      } else {
        return 0;
      }
    },
    returnMaxPrice() {
      if (this.priceFilterRange) {
        return Number(this.priceFilterRange[1]);
      } else {
        return 0;
      }
    },
    returnPrices() {
      if (this.priceFilterRangeDtos) {
        return this.priceFilterRangeDtos;
      } else {
        return "";
      }
    },
    returnListPrices() {
      var list = [];
      for (var clave in this.arrPrices) {
        var elem = this.arrPrices[clave].filter((i) => i >= this.rangePrice[0] && i <= this.rangePrice[1]);
        if (elem.length > 0) {
          list.push(clave);
        }
      }
      return list;
    },
  },
  methods: {
    ...mapActions(["getFilterModelos","getAllElements"]),
    formatValue(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    updateActiveModel(model) {
      let typeModel;
      let arrModel;
      typeModel = model;
      arrModel = this.existFilter.filter((i) => {
        return i.name === typeModel
      });
      this.$emit("onUpdateModel", arrModel);

      this.mutateModel = model.name;
      this.fillAll = "";
      this.defaultRange()
    },
    updateActiveModelPrices() {
      if (this.desarrollo != 'torrevistahermosa') {
        /* let typeModel; */
        let arrModel;
        /* typeModel = model; */
        let list = this.returnListPrices
        let filtered = []
        let unav = this.existFilter.filter((i) => i.available == 0)
        let finalArray = []
        list.forEach((arr) => {
          arrModel = this.existFilter.filter((i) => {
            return i.name === arr && i.available > 0
          });
          filtered = filtered.concat(arrModel);
          finalArray = unav.concat(filtered)
          this.mutateModel = "";
          this.value_2 = 0
        })
        if (finalArray.length == 0) {
          this.$emit("onUpdateModel", unav);

        } else {
          this.$emit("onUpdateModel", finalArray);
        }
        this.fillAll = "active__btn-deptos";
        /*  this.mutateModel = model.name; */
      } else {
        let arrModel;
        let unav = [];
        let filtered = []
        let list = this.returnListPrices;
        if (list.length === 0) {
          return;
        }
        let finalArray = [];
        list.forEach((arr) => {
          arrModel = this.existFilter.filter((i) => {
            return i.name === arr;
          });
          filtered = filtered.concat(arrModel);
          finalArray = unav.concat(filtered);
          this.mutateModel = "";
          this.value_2 = -1;
        });
        this.$emit("onUpdateModel", finalArray);
        this.fillAll = "active__btn-deptos";
      }
    },
    showAllModels() {
      this.getFilterModelos(this.existFilter);
      this.fillAll = "active__btn-deptos";
      this.mutateModel = "";
      this.value_2 = null;
      this.defaultRange()
      this.$emit("defaultDetailDepto")
    },
    fillActive(model) {
      if (this.mutateModel === model.name) {
        return "active__btn-deptos";
      } else {
        return "desactive__btn-casas";
      }
    },
    defaultRange() {
      if (this.returnMinPrice !== undefined && this.returnMaxPrice !== undefined) {
        this.rangePrice = [this.returnMinPrice, this.returnMaxPrice];
      }
    },
    detectedDevelop() {
      if (this.desarrollo == "torrespaseodelparque") {
        this.name = "PISO";
        this.minVal = 0
        this.value_2 = 0
      } else if (this.desarrollo == 'torreaireaplus') {
        this.name = "NIVEL";
        this.minVal = 1
        this.value_2 = 1
      } else if (this.desarrollo == 'canadas_deptos') {
        this.name = "NIVEL";
        this.minVal = 0
        this.value_2 = 0
      } else if (this.desarrollo == 'torrespanorama') {
        this.name = "PISO"
        this.minVal = 1
        this.value_2 = 1
      } else if (this.desarrollo =="torrevistahermosa") {
        this.name = "NIVEL"
        this.minVal = -1
        this.value_2 = -1
      }

    },
  },
  mounted() {
    this.detectedDevelop();
    this.defaultRange()
    this.arrPrices = this.returnPrices;
  },
  created() { },
  updated() { },
  beforeDestroy() {
    this.closeIcon= faFilter,
    this.fillAll= "active__btn-deptos",
    this.mutateModel= "",
    this.iconCircle= faCircle,
    this.value_2= null,
    this.rangePrice= "",
    this.name= "",
    this.arrPrices= "",
    this.minVal= 0,
    this.openFilter= false
  },

};
</script>

<style>
.rangeprice-custom.range-depas-levels .vue-slider-process {
  background: transparent;
}
@media (min-width:768px) {
  
}
</style>
<style scoped>
.range__container-item {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding-top: 2rem;
}

.range__container-item.range-price-container.torre-slider-wrapper {
  flex-direction: column;
}

.range-numbers {
  font-size: 1.4rem;
  /* min-width: 40px; */

  /* width: 25%; */
  font-weight: 700;
}

.range-buttons {
  width: 100%;
  max-width: 300px;
}
.range-buttons.torre-large-buttons {
  width: 100%;
  max-width: 600px;
}

.rangeprice-custom .vue-slider-dot-handle {
  background: #152541;
}

.rangeprice-custom .vue-slider-process {
  background: #152541;
}

.rangeprice-custom .vue-slider-dot-tooltip-inner {
  background: #152541;
  border-color: #152541;
}

.range-numbers-left {
  text-align: right;
  padding-right: 15px;
}

.range-numbers-right {
  text-align: left;
  padding-left: 15px;
}

.prices-depas {
  padding-bottom: 5rem;
  padding-top: 2rem;
}

.filters__content {
  width: 100%;
}

.filters__mobile-fixed {
  position: fixed;
  top: 0;
  background-color: white;
  z-index: 3;
}

@media (min-width: 1201px) {
  .range__container-title {
    font-size: 1.8rem;
  }

  .filters__mobile {
    display: none;
  }
}

@media (max-width: 1200px) {
  .range__container-title {
    font-size: 2.3rem;
  }

  .filters__web {
    display: none;
  }

  .open-filter {
    background: white;
  }
}

.availables__casas-box {
  padding-bottom: 3rem;
}

@media(min-width:768px) {
  .availables__deptos-title {
    flex: 25%;
  }
  
  .box__rangers-filters {
    flex: 74%
  }
  .custom__apartments-filter-custom{
    flex:20% ;
  }
  .custom__apartments-filter-custom .availables__deptos-buttons{
    margin: 0;
  }
  .box__filters {
    display: flex;
    align-items: baseline;
    justify-content: space-evenly;
  }

  .box__filters .contents-rangers.prices-depas {
    width: 65%;

  }

  .box__filters .contents-rangers {
    width: 40%;

  }
}

@media (max-width: 767.67px) {
  .range__container-title {
    font-size: 2rem;
  }
}
@media (max-width: 500.67px) {
  .range__container-title{
    padding-left: 15px;
    padding-right: 15px;
  }
  .range__container-item.range-price-container {
    width: 85%;
    margin: auto;
  }
}
</style>